export const roundsData = {
  firstRound: {
    name: "Recruiter Round",
  },
  secondRound: {
    name: "L1 Hiring Manager Round",
  },
};
